// src/pages/Legal/PrivacyPolicyPage.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { privacyPolicy } from '../../data/legal';
import LegalDocument from './LegalDocument';

const PrivacyPolicyPage = () => (
    <>
        <Helmet>
            <title>Privacy Policy - EcomBuddha</title>
            <meta name="description" content="How EcomBuddha collects, uses, shares, and protects your personal data." />
        </Helmet>
        <LegalDocument document={privacyPolicy} />
    </>
);

export default PrivacyPolicyPage;
